<template>
	<div class="external-loading-wrapper">
		<div class="loading-wrapper">
			<div class="loading-wrapper-box">
				<div class="loading-dot-wrapper">
					<div class="loading-dot"></div>
				</div>
				<div class="loading-dot-wrapper">
					<div id="second-loading-dot" class="loading-dot"></div>
				</div>
			</div>
			<div class="loading-text">{{ $t('loading') }}...</div>
		</div>
	</div>
</template>
<script>
export default {
	mounted() {
		this.$announcer.polite(this.$t('pageLoading'));
	}
};
</script>
<style lang="scss" scoped>
.external-loading-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: #868b97;
	z-index: 9999;

	.loading-wrapper {
		margin: auto;
		text-align: center;
		height: 116px;
		width: 156px;
		border: 1px solid #dde4e6;
		border-radius: 8px;
		background-color: #ffffff;
		box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);

		.loading-wrapper-box {
			.loading-dot-wrapper {
				display: inline-block;
				margin-top: 40px;
				width: 20px;
				height: 20px;

				.loading-dot {
					height: 14px;
					width: 14px;
					background-color: $active-page-color;
					border-radius: 50%;
					animation-name: blinking;
					animation-duration: 1s;
					animation-iteration-count: infinite;

					/* Standard syntax */
					@keyframes blinking {
						0% {
							transform: scale(0.3);
						}
						50% {
							transform: scale(1);
							background-color: #2cb6f8;
						}
						100% {
							transform: scale(0.3);
						}
					}
				}
				#second-loading-dot {
					animation-delay: 0.5s;
				}
			}
		}
		.loading-text {
			height: 16px;
			width: 67px;
			color: $font-dark;
			font-family: 'RobotoMedium';
			font-size: 12px;
			font-weight: 500;
			letter-spacing: 1px;
			line-height: 16px;
			text-align: center;
			margin: auto;
			margin-top: 8px;
			text-transform: uppercase;
		}
	}
}
</style>
